import { render, staticRenderFns } from "./TablaOfertas.vue?vue&type=template&id=63c4fb23"
import script from "./TablaOfertas.vue?vue&type=script&lang=js"
export * from "./TablaOfertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports